import ih from 'immutability-helper';
import createFileSystemReducerWithNamedType from 'store/hoReducers/fileSystem/reducer';
import initialState from './initialState';
import * as types from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  [types.GET_TEST_SETS_LIST_REQUEST]: () =>
    ih(state, {
      list: {
        isLoading: {
          $set: true,
        },
      },
    }),
  [types.GET_TEST_SETS_LIST_SUCCESS]: () =>
    ih(state, {
      list: {
        isLoading: {
          $set: false,
        },
        data: {
          items: {
            $set: action.payload.testSets,
          },
          count: {
            $set: action.payload.count,
          },
        },
      },
    }),
  [types.GET_TEST_SETS_LIST_ERROR]: () =>
    ih(state, {
      list: {
        isLoading: {
          $set: false,
        },
        error: {
          $set: action.payload.error,
        },
      },
    }),
  [types.GET_TEST_SET_REQUEST]: () =>
    ih(state, {
      open: {
        isLoading: {
          $set: true,
        },
      },
    }),
  [types.GET_TEST_SET_SUCCESS]: () =>
    ih(state, {
      open: {
        isLoading: {
          $set: false,
        },
        data: {
          $set: action.payload.testSet,
        },
      },
    }),
  [types.GET_TEST_SET_ERROR]: () =>
    ih(state, {
      open: {
        isLoading: {
          $set: false,
        },
        error: {
          $set: action.payload.error,
        },
      },
    }),
  [types.UPDATE_TEST_SETS_PAGINATION_PARAMS]: () =>
    ih(state, {
      list: {
        paginationOptions: {
          $set: action.payload.paginationOptions,
        },
      },
    }),
  [types.SELECT_TEST_SET]: () =>
    ih(state, {
      open: {
        data: {
          $set: action.payload.testSet,
        },
      },
    }),
  [types.DESELECT_TEST_SET]: () =>
    ih(state, {
      open: {
        data: {
          $set: {},
        },
      },
    }),
  [types.GET_TEST_SETS_FILES_REQUEST]: () =>
    ih(state, {
      all: {
        isLoading: {
          $set: true,
        },
      },
      open: {
        data: {
          $set: {},
        },
      },
    }),
  [types.UPDATE_TEST_SETS_BLOB_SUCCESS]: () =>
    ih(state, {
      all: {
        data: {
          $set: action.payload.files.map(f =>
            f.id === action.payload.file.id
              ? {
                  ...f,
                  lastUpdateTimestamp: Date.now(),
                  contents: action.payload.contents,
                }
              : f,
          ),
        },
      },
      show: {
        isSaving: {
          $set: false,
        },
      },
    }),
});

export default createFileSystemReducerWithNamedType(
  'TEST_SETS',
  initialState,
  reducerHandlers,
);
